import type { ErrorEvent } from "@sentry/browser";

const EXTENSION_URL = /^(chrome|moz|safari|safari-web|ms-browser)-extension:\/\//;

/**
 * Errors that tell nothing about the app, matched by Sentry against the type and message of the error:
 * - a script of another origin (browser extension, third-party script) threw: the browser hides its error
 * - the browser postponed the notifications of a ResizeObserver to the next frame, which is harmless
 */
export const ignoredErrors = [
    "Script Error: See Browser Console for Detail",
    "ResizeObserver loop",
];

/**
 * Whether the error went through a browser extension: it injects scripts in the page (custom elements, which then
 * fail in the polyfill of the web components) or wraps fetch. The extension frame is not always the last one, which
 * is the only one that `denyUrls` looks at.
 */
export function isFromBrowserExtension(event: ErrorEvent): boolean {
    return event.exception?.values?.some((exception) =>
        exception.stacktrace?.frames?.some((frame) => EXTENSION_URL.test(frame.filename ?? "")),
    ) ?? false;
}
